import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'

type ArrayAnswerProps = {
  title: string
  description: string
  fields: {
    linkId: string
    text: string
  }[]
  value: Record<string, string | string[]>[]
}

export const ArrayAnswer = ({ title, description, fields, value }: ArrayAnswerProps) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.Spacing.Space2}>
      <Span type='BodyMediumBold' color={theme.Colors.Neutrals.Darkest}>
        {`${title && description ? `${title}: ` : title || ''}${description}`}
      </Span>
      <FlexColumn gap={theme.UI.Spacing.Space4}>
        {value.map((item, itemIndex) => (
          <FlexColumn
            key={itemIndex}
            gap={theme.UI.Spacing.Space1}
            style={{
              padding: theme.UI.Spacing.Space2,
            }}
          >
            {fields?.map((field) => {
              if (!item[field.linkId]) {
                return null
              }

              const rawItem = item[field.linkId]
              let fieldValue: string[] = []

              if (typeof rawItem === 'string') {
                const rawValue = rawItem.trim()
                if (rawValue === '_custom') {
                  const customValue = item[`${field.linkId}_custom`]
                  fieldValue = [customValue ? String(customValue).trim() : rawValue]
                } else {
                  fieldValue = [rawValue]
                }
              } else if (Array.isArray(rawItem)) {
                fieldValue = rawItem.map((v: string) => {
                  if (String(v).trim() === '_custom') {
                    const customValue = item[`${field.linkId}_custom`]
                    return customValue ? String(customValue).trim() : v
                  }
                  return String(v).trim()
                })
              }

              return (
                <Span key={field.linkId} type='BodyMediumRegular' color={theme.Colors.Neutrals.Darker}>
                  {`${field.text}: ${fieldValue.join(', ')}`}
                </Span>
              )
            })}
          </FlexColumn>
        ))}
      </FlexColumn>
    </FlexColumn>
  )
}
